interface IWizardProgressProps {
  step: number;
}

const WizardProgress = ({ step }: IWizardProgressProps) => {
  return (
    <div className="flex flex-col items-center justify-center px-0 py-4">
      <div className="flex items-center justify-center gap-3">
        {[1, 2, 3].map((dotStep) => (
          <div
            key={dotStep}
            className={`size-2 shrink-0 rounded-full bg-white ${dotStep === step ? 'opacity-100' : 'opacity-20'}`}
          />
        ))}
      </div>
    </div>
  );
};

export default WizardProgress;
